import React from "react";
import { CompanyCardData } from "./types";

interface Props {
  rows: CompanyCardData["snapshot_rows"];
}

// A negative P/E (loss-making company) isn't meaningful, so show N/A.
const displayValue = (row: Props["rows"][number]): string => {
  if (row.label?.trim().toLowerCase() === "p/e ratio") {
    const pe = parseFloat(String(row.value).replace(/,/g, ""));
    if (!isNaN(pe) && pe < 0) return "N/A";
  }
  return row.value;
};

const QuickSnapshot: React.FC<Props> = ({ rows }) => (
  <div className="vi-glass-card p-5">
    <div className="flex items-center justify-between mb-3">
      <h4 className="font-serif text-[16px] font-semibold text-[#23312E] m-0">
        Quick snapshot (LTM)
      </h4>
    </div>

    {rows.map((row, i) => (
      <div
        key={i}
        className={`flex justify-between text-[13.5px] py-1.5 ${
          i < rows.length - 1 ? "border-b border-dashed border-[#E4E0D6]" : ""
        }`}
      >
        <span className="text-[#5C6B66]">{row.label}</span>
        <span className="font-semibold text-[#23312E]">{displayValue(row)}</span>
      </div>
    ))}
  </div>
);

export default QuickSnapshot;
